import React, { useState, useEffect } from "react";
import LinkButton from "../Manager/LinkButton";
//Import Icons
import SearchIcon from "../../images/SearchIcon.svg";
import clearTextIcon from "../../images/clearTextIcon.svg";

//Import styles
import "../../styles/components/ModuleSearchField.scss";

const RoundedSearchTextField = ({
  inlineButton = false,
  placeholder = "Search...",
  onTextChange,
  handleSearch,
  isResetClicked,
  expandable,
  inputValue = "",
  handleCrossIcon,
  fetchAllTemplates,
  setIsSearchBarEmpty,
  isSearchBarEmpty,
  isModuleScreen,
  setSearchText,
  setValues,
  values,
  searchReference,
  handleReset,
  searchInitated,
}) => {
  // const [isSearchBarEmpty, setIsSearchBarEmpty] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  // useEffect(() => {
  //   if (isResetClicked) {
  //     clearTextField();
  //     handleCrossIcon()
  //   }
  // }, [isResetClicked]);
  // useEffect(() => {
  //   if (inputValue && inputValue.trim()) {
  //     setIsSearchBarEmpty(false);
  //   } else {
  //     setIsSearchBarEmpty(true);
  //   }
  // }, [inputValue]);
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const clearTextField = () => {
    const element = document.getElementById("mf-search-field");
    if (element) {
      element.value = "";
      setIsSearchBarEmpty(true);
      onTextChange(element.value);
      setSearchText("");
      setValues({
        ...values,
        moduleNameArray: "",
      });
      if (searchInitated) {
        handleReset();
      }
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch(event);
    }
  };
  const handleSearchClick = (event) => {
    handleSearch(event);
  };
  return (
    <div className={`mf-rounded-search }`}>
      <div className="d-flex align-items-center">
        <img src={SearchIcon} alt="" className="search-icon" />
        <input
          id="mf-search-field"
          type="text"
          value={inputValue || ""}
          // value={inputValue || ""}
          placeholder="Search By 'Module Name / ID'"
          className="search-input "
          autoComplete="off"
          onKeyPress={handleKeyPress}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onDrop={(e) => e.preventDefault()}
          onChange={(e) => {
            if (e.target.value?.trim().length > 0) {
              setIsSearchBarEmpty(false);
            } else {
              setIsSearchBarEmpty(true);
            }
            onTextChange(e.target.value);
          }}
          ref={searchReference}
        />

        {inlineButton && (
          <LinkButton
            className=""
            handleClick={(event) => {
              handleSearchClick(event);
            }}
            disabled={isSearchBarEmpty}
            notAllowed={isSearchBarEmpty ? true : false}
            title="SEARCH"
            height="42px"
            color="#949494"
          />
        )}

        {!isSearchBarEmpty && (
          <img
            src={clearTextIcon}
            alt=""
            className=""
            style={{ cursor: "pointer" }}
            onClick={(event) => {
              clearTextField();
              // handleCrossIcon();

              //handleSearchClick("searchBarEmpty");
            }}
          />
        )}
      </div>
    </div>
  );
};

export default RoundedSearchTextField;
